export const links = [
    {
        title: "Home",
        href: "/"
    },
    {
        title: "Categories",
        href: "/Categories"
    },
    {
        title: "Top rated",
        href: "/games"
    },
    {
        title: "Top Grossing",
        href: "/games"
    },
    {
        title: "Wishlist",
        href: "/games"
    }
]

export const footerLinks = [
    {
        title: "Contact us",
        href: "/"
    },
    {
        title: "About us",
        href: "/"
    },
    {
        title: "Socials",
        href: "/"
    },
    {
        title: "Community",
        href: "/"
    }
]